/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardMiningData model module.
 * @module model/DashboardMiningData
 * @version 1.0
 */
class DashboardMiningData {
    /**
     * Constructs a new <code>DashboardMiningData</code>.
     * @alias module:model/DashboardMiningData
     */
    constructor() { 
        
        DashboardMiningData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardMiningData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardMiningData} obj Optional instance to populate.
     * @return {module:model/DashboardMiningData} The populated <code>DashboardMiningData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardMiningData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('miningPer')) {
                obj['miningPer'] = ApiClient.convertToType(data['miningPer'], 'Number');
            }
            if (data.hasOwnProperty('miningXper')) {
                obj['miningXper'] = ApiClient.convertToType(data['miningXper'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardMiningData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardMiningData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
DashboardMiningData.prototype['targetDate'] = undefined;

/**
 * @member {Number} miningPer
 */
DashboardMiningData.prototype['miningPer'] = undefined;

/**
 * @member {Number} miningXper
 */
DashboardMiningData.prototype['miningXper'] = undefined;






export default DashboardMiningData;

